import { DriveStep } from 'driver.js';

export const getTutorialSteps = (): DriveStep[] => [
    {
        element: '#fev2-header',
        popover: {
            title: 'Finance Engine V2',
            description: 'Bienvenido al nuevo Finance Engine. Aquí podrás gestionar planes, variables y conceptos de forma más intuitiva.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '#fev2-tab-plans',
        popover: {
            title: 'Plans',
            description: 'Aquí verás todos los planes contables. Cada plan define la frecuencia de corte y agrupa conceptos y variables.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '#fev2-tab-variables',
        popover: {
            title: 'Variables',
            description: 'Las variables son valores reutilizables en fórmulas. Pueden ser números simples, condiciones o tablas de valores por país/proveedor.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '#fev2-tab-concepts',
        popover: {
            title: 'Concepts',
            description: 'Los conceptos son las reglas de cobro. Cada concepto tiene condiciones que deben cumplirse y una fórmula que calcula el monto.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '#fev2-stats',
        popover: {
            title: 'Dashboard',
            description: 'Aquí verás un resumen rápido: total de planes, variables y conceptos configurados.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '#fev2-tutorial-btn',
        popover: {
            title: '¿Necesitas ayuda?',
            description: 'Puedes volver a ver este tutorial en cualquier momento haciendo clic en este botón.',
            side: 'left',
            align: 'start',
        },
    },
];
